var Vue = require('vue');
var AssignmentList = require('./components/AssignmentList.vue').default;
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
var sanitize = require('@/lib/utils.js').sanitize;
const store = require('@/lib/store').default;

module.exports = function() {
    const assignmentList = new Vue({
        el: '#assignment-list',
        components: {
            'assignment-list': AssignmentList
        },
        store
    });

    $(document).one('pjax:end', () => {
        assignmentList.$destroy();
    });

    new IndexView();

    // Enable columnator
    new Columnator();

    // Autocomplete
    var judgeField = $('#judge');

    judgeField.select2({
        ajax: {
            url: '/assignment/autocomplete',
            dataType: 'json',
            delay: 250,
            data: function(searchTerm) {
                return {
                    name: searchTerm
                }
            },
            results: function(data) {
                return {
                    results: data
                }
            },
            cache: true
        },
        formatResult: function(user) {
            return sanitize(user.fullName);
        },
        formatSelection: function(user) {
            return sanitize(user.fullName);
        },
        initSelection: function(element, callback) {
            var id = $(element).val();

            if (id !== '') {
                $.ajax('/assignment/judge/' + id, {
                    dataType: 'json'
                }).done(function(data) {
                    callback(data);
                });
            }
        },
        minimumInputLength: 3
    });
};
